import { fetcher } from '@data/utils/api/fetcher/fetcher';
import { useQuery } from '@tanstack/react-query';
import { byProductDisplayOrder, MAGAZINE_GROUP_CODE } from 'eds-common';

export interface ApplicationProduct {
  id: string;
  productCode: string;
  productName: string;
  thumbnailUrl?: string;
  accessType?: string;
  parentApplication?: string;
  groupCode?: string;
  applicationCode: string;
  applicationLabel: string;
  gradeHigh?: string;
  gradeLow?: string;
  subtitle?: string;
  description?: string;
}

export interface Application {
  applicationCode: string;
  applicationLabel: string;
  applicationDescription: string;
  applicationIconSrc: string;
  products: ApplicationProduct[];
}

const getApplications = (): Promise<Application[]> =>
  fetcher<Application[]>('/composite/applications', {
    service: '/fulfillment',
    version: '/v2',
  });

/** Query options for use with `queryClient.ensureQueryData` in route loaders. */
export function applicationsQuery() {
  return {
    queryKey: ['fulfillment-applications'],
    queryFn: getApplications,
  };
}

const byApplicationDisplayOrder = byProductDisplayOrder<Application>({
  name: (application) => application.applicationLabel,
  isMagazine: (application) =>
    application.products.some(
      (product) => product.groupCode === MAGAZINE_GROUP_CODE
    ),
});

export function useApplications() {
  return useQuery({
    ...applicationsQuery(),
    select: (data) => [...data].sort(byApplicationDisplayOrder),
  });
}
